/**
 * Removes all falsy values from an array.
 *
 * This function takes an array as input and returns a new array with all falsy values removed.
 * Falsy values in JavaScript include `false`, `0`, `""` (empty string), `null`, `undefined`, and `NaN`.
 *
 * (migrated from pace-core:utilities/compact.ts to have it available in this library
 *
 * @template T - The type of elements in the array.
 * @param {T[] | null | undefined} array - The array to compact. It can be an array of any type, or `null`, or `undefined`.
 * @returns {T[]} A new array with all falsy values removed. If the input array is `null` or `undefined`, an empty array is returned.
 *
 * @example
 * // Removes falsy values from an array of numbers
 * const numbers = [0, 1, false, 2, '', 3, null, undefined, NaN];
 * console.log(compact(numbers)); // Output: [1, 2, 3]
 */
export const compact = <T>(array?: T[] | null): T[] => array?.filter((x) => !!x) || [];
